import { useContext } from 'react'
import { CountryCode } from '@carsys/enums/country-code'

import { LocaleContext } from '@cbgms/base/locale/LocaleContext'
import { IAddressFormatter } from '@cbgms/base/utils/address/address'
import { addressFormatters } from '@cbgms/base/utils/address'

export const useAddressFormatter = (overrideCountry?: CountryCode): IAddressFormatter => {
  const { country: shopCountry } = useContext(LocaleContext)
  const country = overrideCountry || shopCountry

  return addressFormatters[country] || addressFormatters[CountryCode.NL] // fall back on dutch renderer, (instead of crashing)
}
